import React, { useState, useEffect } from "react";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const SearchResultsImagePopup2 = (props) => {

    // Property details images lightbox
    var propertyImagePopup = []
    
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const openLighboxMobile = (e, ind) => {
        e.preventDefault();
        setPhotoIndex(ind);
        setIsOpen(true);
    } 

    props?.propertyImage?.length > 0 && props?.propertyImage.filter(item => item !== null).map(item => propertyImagePopup.push(item.url))
    
    //propertyImagePopup.push(props?.propertyImage && props?.propertyImage[0]['440x320'])
	// Property details images lightbox
    if(props?.imgLength){
        propertyImagePopup = propertyImagePopup.slice(0, props?.imgLength)
    }
    var image_count = propertyImagePopup.length;

    return (
        <React.Fragment>
            {
                props.tag === "auction" ? 
                <li className="list-inline-item auction-floorplan">
                    <a href="javascript:void(0)" onClick={(e) => openLighboxMobile(e,0)}>
                        <i className="icon-camera-black"></i>
                    </a>                    
                    {
                       image_count !=0 &&
                        <span className="">1/{image_count}</span>
                    }                    
                </li>
                :
                <div className="image-wrap" onClick={(e) => openLighboxMobile(e,0)}>
                    <i className="icon-camera" ></i>
                    {
                        image_count !=0 &&
                        <div className="image-count">1/{image_count}</div>
                    }
                </div>
            }

            {isOpen && propertyImagePopup.length != 0 && (
                <Lightbox
                    wrapperClassName="light-box-image-zoom"
                    mainSrc={propertyImagePopup[photoIndex]}
                    nextSrc={
                        propertyImagePopup[
                            (photoIndex + 1) % propertyImagePopup.length
                        ]
                    }
                    prevSrc={
                        propertyImagePopup[
                            (photoIndex + propertyImagePopup.length - 1) %
                            propertyImagePopup.length
                        ]
                    }
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + propertyImagePopup.length - 1) % propertyImagePopup.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % propertyImagePopup.length)
                    }
                />
            )}
        </React.Fragment>
    )
}

export default SearchResultsImagePopup2